import * as React from 'react';
import { SVGProps } from 'react';

const SvgQuotes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.25 5.75v-2.5h-15V9.5h5.625v11.25H20.75v-15h-2.5ZM4.5 8.25V4.5H17v1.25H8.875v2.5H4.5Zm15 11.25h-9.375V7H19.5v12.5Z'
      fill='#000'
    />
    <path
      d='M12.625 8.875h-1.25v1.25h1.25v-1.25ZM18.25 8.875h-4.375v1.25h4.375v-1.25ZM12.625 12.625h-1.25v1.25h1.25v-1.25ZM18.25 12.625h-4.375v1.25h4.375v-1.25ZM12.625 16.375h-1.25v1.25h1.25v-1.25ZM18.25 16.375h-4.375v1.25h4.375v-1.25Z'
      fill='#000'
    />
  </svg>
);

export default SvgQuotes;
